import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from "./context/AuthContext";
import { PaymentProvider } from "./context/PaymentContext";
import { GeoProvider } from "./context/GeoContext";
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import "./i18n";
import './styles/global.css';
import './styles/fonts.css';
import './styles/WinningsTicker.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <GeoProvider>
        <AuthProvider>
          <PaymentProvider>
            <App />
          </PaymentProvider>
        </AuthProvider>
      </GeoProvider>
    </Router>
  </React.StrictMode>
);
